export enum ObjectModelActionCapability {
  labelable = 1,
  formLinkable = 2,
  availabilityConditionable = 3,
  bulkActionable = 4,
  confirmationCustomizable = 5,
  loggable = 6,
  documentLinkable = 7,
  noteRequireable = 8,
  runProcessable = 9,
  accountLinkable = 10,
  emailStyleable = 11

}
